<template>
  <div class="msgtypeText">
    <p class="revoke_p" v-if="items.msgtype === 'text'">{{ items.content.content }}</p>
    <p class="revoke_text" v-if="items.msgtype === 'revoke'">{{ items.to_name }}撤回了一条消息</p>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.msgtypeText {
  padding: 0 12px;
  box-sizing: border-box;
  .revoke_p {
    font-size: 14px;
    color: #303133;
    letter-spacing: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 24px;
  }
  .revoke_text {
    padding: 0 8px;
    background: #f5f7fa;
    border-radius: 4px;
    font-size: 14px;
    color: #909399;
    line-height: 28px;
    display: inline-block;
  }
}
</style>
